import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {SideMenuService} from "../../../../../services/side-menu.service";
import { ClaimDocumentsComponent } from "../../../../claim-documents/claim-documents.component";
import { ClaimService } from "../../../../../services/claim.service";
import { DocumentHelperService } from "../../../../../services/document-helper.service";
import { TransactionInfoService } from "../../../../../services/transaction-info.service";
import { HttpClient } from "@angular/common/http";
import { DocumentFormFactoryService } from "../../../../../services/document-form-factory.service";
import { ClaimTypes } from "../../../../../model/claim-type.model";
import { SpinnerService } from '../../../../../core/spinner/spinner.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {Claim} from "../../../../../model/claim.model";

declare var $: any;

@Component({
    selector: 'app-liablity-upload-document',
    templateUrl: './liablity-upload-document.component.html',
    styleUrls: ['./liablity-upload-document.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LiablityUploadDocumentComponent extends ClaimDocumentsComponent implements OnInit {

    public upLoadFileModel: FormGroup;
    showTotalBox = false;
    claim: Claim;
    
    constructor(private fb: FormBuilder,
        public sideMenuService: SideMenuService, 
        claimService: ClaimService,
        documentHelperService: DocumentHelperService,
        transactionInfoService: TransactionInfoService,
        http: HttpClient,
        documentFormFactoryService: DocumentFormFactoryService, spinnerService: SpinnerService, modalService: NgbModal) {
                super(claimService, documentHelperService, transactionInfoService, http, documentFormFactoryService, spinnerService, modalService);
                this.setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_LIAB]);
    }

    ngOnInit() {

        this.pushGAViewLiabilityDocs();
        this.upLoadFileModel = this.fb.group(
            {
                airTicket: [],
                photoShowing: [],
                summons: [],
                otherItems: this.fb.array([this.createItem()])

            });
            super.ngOnInit();
            this.claim = this.claimService.getClaim();
    }

    addFile() {
        let items = this.upLoadFileModel.get('otherItems') as FormArray;
        items.push(this.createItem());
    }

    createItem(): FormGroup {
        // setTimeout(() => {
        //   console.log('lossType1111', this.el.nativeElement.value);
        //   this.selectType = this.el.nativeElement.value;
        // });
        return this.fb.group({
            otherFile: [],


            // detail: this.fb.group(that.createDetail('mobile'))
        });
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    goToNext() {
        this.sideMenuService.emitClaimComplete({claimTypeId: 14, subMenuIndex: 2});
        this.sideMenuService.emitProgress(1);
    }

    //Google Analytics
    pushGAViewLiabilityDocs() {
        (<any>window).dataLayer.push({
            'pageStep': 'Personal Liability – Document Upload',
            'vPath': '/claim/personal-liability/documents',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 6},	//Step6-DocumentUpload
                }
            }
        });
    }
}
